import { getClasses, formatCurrency } from "../../utils";
import { useAppSelector } from "../../hooks";
import classes from "../../styles/BetBoost.module.css";

const ExtraBetLabel: React.FC<{ disabled: boolean; hidden: boolean }> = ({
  disabled,
  hidden,
}) => {
  const { betBoost, stake, currency } = useAppSelector((state) => {
    return {
      betBoost: state.betBoost,
      stake: state.selectors.stake,
      currency: state.details.currency,
    };
  });
  const value = formatCurrency(stake.value * (betBoost?.value ?? 1), currency);
  const disabledClass = disabled ? "disabled" : "";
  const hiddenClass = hidden ? "hidden" : "";

  if (!betBoost || !betBoost.active) return null;

  return (
    <div
      className={getClasses(classes, "extra-bet", disabledClass, hiddenClass)}
    >
      <div className={getClasses(classes, "extra-bet-inner")}>
        <div className={getClasses(classes, "extra-bet-label")}>{value}</div>
      </div>
    </div>
  );
};

export default ExtraBetLabel;
